<template>
    <div class="page-content header-clear-medium">

		<div class="content mt-0">
			<router-link :to="{ name: 'tatib.data', query:filterParams }" class="btn-full btn bg-red-dark btn-s">Lihat Data Tatib</router-link>
		</div>

		<div class="card card-style">
			<div class="content">
				<h3 class="text-center mb-3 color-blue-dark">Statistik Tatib</h3>

				<ReportFilter 
					:type-filter.sync="filterParams.type" 
					:daily-time.sync="filterParams.date" 
					:monthly-time.sync="filterParams.month" 
					:range-date-from.sync="filterParams.date_from" 
					:range-date-to.sync="filterParams.date_to" 
					:tingkat-filter.sync="filterParams.kelas_id" 
					:rombel-filter.sync="filterParams.rombel_id" 
					:student-filter.sync="filterParams.student_id" 
					@get-data-daily="getDataTatibDaily()"
					@get-data-monthly="getDataTatibMonthly()"
					@get-data-all="getDataTatibAll()"
					@get-data-range="getDataTatibRange()"
				/>

				<div class="mt-3">
					<!-- <Pie
						v-if="chartData.labels.length > 0"
						:chart-options="chartOptions"
						:chart-data="chartData"
						chart-id="pie-chart"
						dataset-id-key="label"
						:plugins="[]"
						css-classes=""
						:styles="{}"
						:width="400"
						:height="400"
					/> -->
					<highcharts v-if="chartData.labels.length > 0" :options="tatibChartOptions"></highcharts>
					<div class="alert alert-warning" v-else>
						Data Tidak Ditemukan!
					</div>
				</div>
			</div>
		</div>
        
    </div>
</template>

<script>
import { 
// 	mapMutations, 
	mapActions, mapState 
} from 'vuex'
import { Pie } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)
import moment from 'moment'
import ReportFilter from '../components/form/ReportFilter.vue'

export default {
    name: 'Home',
    components: {
		// Pie, 
		ReportFilter, 
    },
    data() {
        return {
					filterParams : {
						type: 'daily',
						month: moment().format('MM'),
						date: moment().format('YYYY-MM-DD'),
						kelas_id: '',
						rombel_id: '',
						student_id: '',
						date_from: moment().format('YYYY-MM-DD'),
						date_to: moment().format('YYYY-MM-DD'),
					},
					chartData: {
						labels: [],
						datasets: [
							{
								backgroundColor: [],
								data: []
							}
						]
					},
					chartOptions: {
						responsive: true,
						maintainAspectRatio: false
					},
					tatibChartOptions: {
						chart: {
							plotBackgroundColor: null,
							plotBorderWidth: null,
							plotShadow: false,
							type: 'pie'
						},
						title: {
							text: 'Laporan Data Tatib'
						},
						series: [{
							name: 'Data Tatib',
							colorByPoint: true,
							data: [],
						}]
					}
        }
    },
    async created() {
		if (this.tatibTypeFilter == 'monthly') {
			this.getDataTatibMonthly()
		} else {
			this.getDataTatibDaily()
		}
    },
	mounted() {
	},
	updated() {
	},
    methods: {
		...mapActions('chartData', ['getChartDataTatib']),
		clearChartData() {
			this.chartData = {
				labels: [],
				datasets: [
					{
						backgroundColor: [],
						data: [],
					}
				]
			}
		},
		getDataTatibDaily() {
			this.getTatibChartData()
		},
		getDataTatibMonthly() {
			this.getTatibChartData()
		},
		getDataTatibRange() {
			this.getTatibChartData()
		},
		getDataTatibAll() {
			this.getTatibChartData()
		},
		async getTatibChartData() {
			this.clearChartData();

			let responseChartDataTatib = await this.getChartDataTatib(this.filterParams)
			let tempChartData = {
				labels: [],
				datasets: [
					{
						backgroundColor: [],
						data: []
					}
				]
			}

			tempChartData.labels = responseChartDataTatib.data[0]
			responseChartDataTatib.data[1].forEach(element => {
				tempChartData.datasets[0].backgroundColor.push(`#${(Math.random()*0xFFFFFF<<0).toString(16)}`)
				tempChartData.datasets[0].data.push(element)
			})

			this.chartData = tempChartData

			let data = responseChartDataTatib.data[0].map((item, index) => {
				return {
					name: item,
					y: responseChartDataTatib.data[1][index]
				};
			});

			this.tatibChartOptions.series[0].data = data
		}
    },
    computed: {
        ...mapState('post', {
            chart_data: state => state.chart_data,
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
